import { render, staticRenderFns } from "./ShopMyOrders.vue?vue&type=template&id=221087c3&scoped=true&"
import script from "./ShopMyOrders.vue?vue&type=script&lang=js&"
export * from "./ShopMyOrders.vue?vue&type=script&lang=js&"
import style0 from "./ShopMyOrders.vue?vue&type=style&index=0&id=221087c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221087c3",
  null
  
)

export default component.exports